import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
    selector: 'app-element-form-order-fields',
    templateUrl: './element-form-order-fields.component.html',
})
export class ElementFormOrderFieldsComponent implements OnInit, OnDestroy {
    @Input() form: FormGroup;

    constructor(
    ) {
    }

    ngOnInit() {
        this.form.setControl('order', new FormGroup({
            number: new FormControl(''),
            date: new FormControl(''),
        }));
    }

    ngOnDestroy(): void {
        this.form.setControl('order', new FormControl(null));
    }
}
